import React from "react";
import Modal from ".";
import { ModalBody, ModalTitle } from "./styles";
import InputSign from "../inputSign";

// Modal de assinatura eletrônica (cadastro E edição) - usado tanto na tela de
// responsável técnico (pages/agronomos/editCreaV2.js) quanto na emissão de
// receita (prescriptionsteps/step3/form.js), pra não divergir no visual (ex.:
// margin) quando só um dos dois lados é alterado - ver mesmo motivo em
// modalUploadCertificado.js, o equivalente pra assinatura digital.
const ModalAssinaturaEletronica = ({ show, onHide, sign, onUpdate, onRemover, removendo, resetKey }) => (
  <Modal show={show} onHide={onHide} align="center" justify="center" responsive width="480px">
    {/* ModalTitle e ModalBody são irmãos (não um dentro do outro - ver ./index.js),
        por isso o gap entra num wrapper próprio em vez de margin:0 + gap num dos
        dois sozinho (que não teria efeito nenhum entre eles). Sem mexer no
        componente compartilhado (ModalTitle é usado em outras 35 telas). */}
    <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: "16px" }}>
      <ModalTitle style={{ margin: 0 }}>Cadastrar assinatura eletrônica</ModalTitle>

      <ModalBody style={{ margin: 0 }}>
        <InputSign
          key={resetKey}
          sign={sign}
          update={onUpdate}
          onRemover={onRemover}
          removendo={removendo}
        />
      </ModalBody>
    </div>
  </Modal>
);

export default ModalAssinaturaEletronica;
